// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__26hAa","dragIcon":"Choice_dragIcon__15svx","left":"Choice_left__3k6-5","input":"Choice_input__DmUft"};